import { BiTable } from 'react-icons/bi';
import { FaBlogger, FaPodcast } from 'react-icons/fa';
import { TbListSearch } from 'react-icons/tb';
import { FiActivity, FiTrendingUp } from 'react-icons/fi';
import {
  FiHome,
  FiFilter,
  FiVideo,
  FiUsers,
  FiMail,
  FiDollarSign,
  FiInbox,
  FiCreditCard,
  FiUploadCloud,
  FiFile,
  FiFileText,
  FiFolder,
  FiUserCheck,
  FiUserPlus,
  FiUser,
  FiUserMinus,
  FiDatabase,
  FiMessageCircle,
} from 'react-icons/fi';

export const LinkItems = [
  {
    name: 'Escritorio',
    icon: FiHome,
    link: '/plataforma/administrador',
    roles: ['admin', 'secretary_admin', 'supervisor_admin', 'marketing', 'community'],
  },
  {
    name: 'Crear Blog',
    icon: FaBlogger,
    link: '/plataforma/administrador/crear-blog',
    roles: ['community'],
  },
  {
    name: 'Crear Podcast',
    icon: FaPodcast,
    link: '/plataforma/administrador/crear-podcast',
    roles: ['community'],
  },
  // Ocultos temporalmente del menú lateral (las páginas y rutas siguen
  // accesibles por URL directa — solo se removieron del sidebar):
  //   - Klazia Studio  → /plataforma/administrador/studio-individual
  //   - Rescate de Videos → /plataforma/administrador/rescate-videos
  //   - Panel de Rescate  → /plataforma/administrador/rescate
  {
    name: 'Pizarrón de noticias',
    icon: BiTable,
    link: '/plataforma/administrador/pizarron',
    roles: ['community'],
  },
  {
    name: 'Prospectos',
    icon: FiFilter,
    link: '/plataforma/administrador/prospects',
    roles: ['marketing'],
  },
  {
    name: 'Filtros Academicos',
    icon: FiFilter,
    subMenu: [
      {
        name: 'Cambiar Semestre',
        link: 'filtro/buscar-semestre',
        roles: ['admin', 'supervisor_admin', 'secretary_admin'],
      },
      {
        name: 'Filtro Estudiantes',
        link: 'filtro/filtro-estudiantes',
        roles: ['admin', 'supervisor_admin', 'secretary_admin'],
      },
      {
        name: 'Reporte de Requisitos',
        link: 'filtro/reporte-requisitos',
        roles: ['supervisor_admin', 'admin'],
      },
      {
        name: 'Seguimiento Académico',
        link: 'filtro/reporte-academico',
        roles: ['supervisor_admin', 'admin'],
      },
      {
        name: 'Excel',
        link: 'filtro/estudiantes',
        roles: ['admin', 'supervisor_admin', 'secretary_admin'],
      },
      {
        name: 'Lista negra',
        link: 'black-list',
        roles: ['admin', 'supervisor_admin'],
      },
      {
        name: 'Promedios anual',
        link: 'promedio',
        roles: ['admin', 'supervisor_admin', 'secretary_admin'],
      },
      {
        name: 'Contenidos programaticos',
        link: 'contenidos-programaticos',
        roles: ['admin', 'supervisor_admin', 'secretary_admin'],
      },
      {
        name: 'Reset Boletines',
        link: 'reset-boletines',
        roles: ['supervisor_admin'],
      },
      {
        name: 'Fechas de materias',
        link: 'fechas-materias',
        roles: ['supervisor_admin'],
      },
    ],
    roles: ['admin', 'secretary_admin', 'supervisor_admin'],
  },
  {
    name: 'Clases en vivo',
    icon: FiVideo,
    link: '/plataforma/administrador/clases-en-vivo',
    roles: ['admin', 'supervisor_admin'],
  },
  {
    name: 'Eventos',
    icon: FiVideo,
    link: '/plataforma/administrador/events',
    roles: ['admin', 'supervisor_admin'],
  },
  {
    name: 'Subir estudiantes graduados',
    icon: FiUploadCloud,
    link: '/plataforma/administrador/subir-estudiantes',
    roles: ['admin', 'supervisor_admin', 'secretary_admin'],
  },
  {
    name: 'Base histórica',
    icon: FiDatabase,
    link: '/plataforma/administrador/base-historica',
    roles: ['admin', 'supervisor_admin'],
  },
  {
    name: 'Asignar colegio',
    icon: FiHome,
    link: '/plataforma/administrador/asignar-colegio',
    roles: ['admin', 'supervisor_admin', 'secretary_admin'],
  },
  {
    name: 'Reporte de Pagos',
    icon: FiCreditCard,
    link: '/plataforma/administrador/filtro/reporte-pagos',
    roles: ['supervisor_admin', 'admin'],
  },
  {
    name: 'Grupos',
    icon: FiUsers,
    link: '/plataforma/administrador/grupos-estudiantes',
    roles: ['admin', 'supervisor_admin'],
  },
  {
    name: 'Emails',
    icon: FiMail,
    subMenu: [
      {
        name: 'Campañas',
        link: 'emails/envios',
        roles: ['admin', 'supervisor_admin', 'community'],
      },
      {
        name: 'Plantillas',
        link: 'emails/plantillas',
        roles: ['admin', 'supervisor_admin', 'community'],
      },
    ],
    roles: ['admin', 'supervisor_admin', 'community'],
  },
  {
    name: 'Pagos',
    stat: true,
    id: 'allPayments',
    icon: FiDollarSign,
    subMenu: [
      {
        name: 'PayU',
        link: 'pagos',
        stat: true,
        id: 'payments',
        roles: ['admin', 'supervisor_admin'],
      },
      {
        name: 'Facturas de pagos',
        link: 'pagos-facturas',
        stat: false,
        id: 'paymentFactures',
        roles: ['admin', 'supervisor_admin', 'secretary_admin'],
      },
      {
        name: 'Órdenes de compra',
        link: 'ordenes-de-compra',
        stat: true,
        id: 'purchaseOrders',
        roles: ['admin', 'supervisor_admin'],
      },
      {
        name: 'Historial Pagos',
        link: 'historial-de-pagos',
        stat: false,
        id: 'historyPayments',
        roles: ['supervisor_admin'],
      },
      {
        name: 'Devoluciones',
        link: 'devoluciones',
        stat: true,
        id: 'refunds',
        roles: ['admin', 'supervisor_admin', 'secretary_admin', 'community', 'coordinator'],
      },
    ],
    roles: ['admin', 'supervisor_admin', 'secretary_admin'],
  },
  {
    name: 'Asesoras',
    icon: FiUserCheck,
    subMenu: [
      {
        name: 'Pagos asesoras',
        link: 'pagos-asesoras',
        roles: ['supervisor_admin'],
      },
      {
        name: 'Prospectos',
        link: 'asesoras/prospectos',
        roles: ['supervisor_admin'],
      },
    ],
    roles: ['supervisor_admin'],
  },

  {
    name: 'Buzón de sugerencias',
    icon: FiInbox,
    link: '/plataforma/administrador/feedback',
    stat: true,
    id: 'feedback',
    roles: ['admin', 'supervisor_admin'],
  },

  {
    name: 'Requisitos Pendientes',
    icon: FiFile,
    link: '/plataforma/administrador/requisitos-pendientes',
    stat: true,
    id: 'pendingRequirements',
    roles: ['admin', 'secretary_admin', 'supervisor_admin', 'coordinator'],
  },

  {
    name: 'Bienvenidas',
    icon: FiUserPlus,
    link: '/plataforma/administrador/bienvenidas',
    stat: true,
    id: 'welcome',
    roles: ['admin', 'supervisor_admin'],
  },
  /* {
    name: 'Estudiantes Atrasados',
    icon: FiUserMinus,
    link: '/plataforma/administrador/estudiantes-atrasados',
    stat: false,
    id: 'welcome',
    roles: ['admin', 'supervisor_admin'],
  }, */
  {
    name: 'Instituciones',
    icon: FiFolder,
    subMenu: [
      {
        name: 'Listado',
        link: 'instituciones',
        roles: ['admin', 'supervisor_admin'],
      },
      {
        name: 'Cobros',
        link: 'instituciones/cobros',
        roles: ['admin', 'supervisor_admin'],
      },
    ],
    roles: ['admin', 'supervisor_admin'],
  },
  {
    name: 'Lista Convenios',
    icon: FiUserCheck,
    link: '/plataforma/administrador/convenios',
    stat: false,
    id: 'welcome',
    roles: ['admin', 'supervisor_admin'],
  },
  {
    name: 'Profesores',
    icon: FiUser,
    link: '/plataforma/administrador/profesores',
    stat: false,
    id: 'actividades',
    roles: ['admin', 'supervisor_admin'],
  },
  //  {
  //    name: 'Efecty',
  //    icon: FiFolder,
  //    link: '/plataforma/administrador/efecty',
  //    roles: ['admin'],
  //  },

  {
    name: 'Afiliados',
    icon: FiUserCheck,
    link: '/plataforma/administrador/afiliados',
    roles: ['admin', 'supervisor_admin'],
  },
  {
    name: 'Pagos asesoras',
    icon: FiDollarSign,
    link: '/plataforma/administrador/pagos-asesoras',
    roles: ['marketing'],
  },

  {
    name: 'Monitoring',
    icon: FiActivity,
    subMenu: [
      {
        name: 'Clases grabadas',
        link: 'monitoring/clases-grabadas',
        roles: ['admin', 'supervisor_admin'],
      },
      {
        name: 'Calificación de actividades',
        link: 'monitoring/calificacion-actividades',
        roles: ['admin', 'supervisor_admin'],
      },
    ],
    roles: ['admin', 'supervisor_admin'],
  },

  {
    name: 'Finanzas',
    icon: FiTrendingUp,
    subMenu: [
      { name: 'Resumen', link: 'finanzas', roles: ['supervisor_admin'] },
      { name: 'Bancos', link: 'finanzas/bancos', roles: ['supervisor_admin'] },
      { name: 'Flujo de caja', link: 'finanzas/flujo-caja', roles: ['supervisor_admin'] },
    ],
    roles: ['supervisor_admin'],
  },

  {
    name: 'Auditoría',
    icon: TbListSearch,
    link: '/plataforma/administrador/auditoria',
    stat: false,
    id: 'auditoria',
    roles: ['supervisor_admin'],
  },
  {
    name: 'Solicitudes de documentos',
    icon: FiFileText,
    link: '/plataforma/administrador/solicitudes-documentos',
    roles: ['admin', 'supervisor_admin', 'secretary_admin'],
  },
  {
    name: 'Ventanilla',
    icon: FiMessageCircle,
    subMenu: [
      {
        name: 'Simulador',
        link: 'ventanilla-simulador',
        roles: ['admin', 'supervisor_admin', 'secretary_admin'],
      },
      {
        name: 'Configuración y documentos',
        link: 'ventanilla-documentos',
        roles: ['admin', 'supervisor_admin', 'secretary_admin'],
      },
    ],
    roles: ['admin', 'supervisor_admin', 'secretary_admin'],
  },
];
